<template>
  <footer class="main-footer">
    <div v-if="willRender(props.blok.extrasText)" class="main-footer__extras">
      <div v-if="props.blok.extrasHeading" class="main-footer__extras-header h5">
        {{ props.blok.extrasHeading }}
      </div>
      <div class="main-footer__extras-text">
        <SepacRichtextResolver :blok="props.blok.extrasText" />
      </div>
      <PflegeDivider
        border-color="mint-darker"
        height="0"
      />
    </div>
    <div class="main-footer__tuev-trustpilot">
      <TrustpilotWidget v-if="!props.blok.isTrustpilotFooterHidden" :blok="{'widget': 'mini'}" />
      <TuevWidget v-if="!props.blok.isTuevFooterHidden">
        TÜV-geprüfte Kundenzufriedenheit für unsere curabox<sup>®</sup> und den pflege.de-Anbietervergleich.
      </TuevWidget>
    </div>

    <PflegeDivider
      v-if="props.blok.footerAddLinks?.length ?? 0 > 0"
      border-color="mint-darker"
      height="0"
    />

    <nav class="main-footer__navigation">
      <div v-if="props.blok.footerAddLinksHeading" class="main-footer__list-header h5">
        {{ props.blok.footerAddLinksHeading }}
      </div>

      <ul v-if="props.blok.footerAddLinks?.length ?? 0 > 0" class="main-footer__links-list">
        <li
          v-for="(item, index) in props.blok.footerAddLinks"
          :key="`${item._uid}_${index}`"
          class="main-footer__list-item"
        >
          <NuxtLink
            :target="item.link?.target"
            :title="item.linkTitel"
            :to="useCalcedLink(item)"
            class="main-footer__list-link"
          >
            <PflegeIcon
              v-if="item.icon !== ''"
              :name="item.icon"
              aria-hidden="true"
              size="l"
              class="main-footer__list-icon"
            />
            <!-- eslint-disable-next-line vue/no-v-html -->
            <span v-html="item.linkLabel"></span>
          </NuxtLink>
        </li>
      </ul>

      <PflegeDivider
        v-if="props.blok.footerAddLinks?.length ?? 0 > 0"
        border-color="mint-darker"
        height="0"
      />

      <ul class="main-footer__disclaimers-list">
        <li
          v-for="(item, index) in props.blok.disclaimerLinks"
          :key="`${item._uid}_${index}`"
          class="main-footer__list-item"
        >
          <NuxtLink
            :target="item.link?.target"
            :title="item.linkTitel"
            :to="useCalcedLink(item)"
            class="main-footer__list-link"
          >
            <!-- eslint-disable-next-line vue/no-v-html -->
            <span v-html="item.linkLabel"></span>
          </NuxtLink>
        </li>
      </ul>
    </nav>
  </footer>
</template>

<script setup>
import { PflegeDivider, PflegeIcon } from '@webcarelbj/shared-components'

const props = defineProps({
  blok: {
    type: Object,
    required: false,
    default: () => ({
      isTuevFooterHidden: false,
      isTrustpilotFooterHidden: true,
      footerAddLinks: [],
      disclaimerLinks: [],
    }),
  },
})
</script>

<style lang="scss" scoped>
.main-footer {
  --width: 80dvw;

  background-color: var(--mint-light);
  display: flex;
  flex-flow: column wrap;
  gap: 1.5rem;
  padding-block: 2.5rem 1.25rem;

  &__tuev-trustpilot {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 1.5rem;
    margin-top: 1rem;

    & :deep(.tuev-widget),
    & :deep(.tp-widget):has(img) {
      width: min(300px, 100%);
      text-align: center;
      padding: 0;
      justify-items: center;

      @media (width < 576px) {
        width: min(192px, 100%);
      }
    }
  }

  &__links-list, &__disclaimers-list {
    list-style: none;
    display: flex;
    flex-flow: column wrap;
    align-items: center;
    gap: 1.5rem;
    justify-content: center;
    width: var(--width);
    margin: auto;
  }

  &__links-list {
    margin-top: 0.5rem;
    margin-bottom: 2rem;
  }

  &__disclaimers-list {
    padding: 2rem 0 1rem 0;

    @media (width >= 576px) {
      flex-direction: row;
    }
  }

  &__list-item {
    margin-block-end: 0;
  }

  &__list-link {
    display: flex;
    align-items: center;
    color: currentcolor;
    font-weight: 700;
    font-size: 1rem;
    line-height: 1.5;
    text-decoration: none;

    &:is(:hover, :active) {
      text-decoration: underline;
      color: currentcolor;
    }
  }

  &__list-icon {
    margin-right: 0.5rem;
    color: currentcolor;
  }

  &__extras {
    &-header, &-text {
      width: var(--width);
      margin-inline: auto;
    }

    &-header {
      margin-bottom: 0.75rem;
    }

    &-text {
      margin-bottom: 2rem;

      & :deep(p) {
        font-size: 1rem;
      }
    }
  }

  &__list-header {
    width: var(--width);
    margin-inline: auto;
    text-align: center;
    margin-top: 0.5rem;
    margin-bottom: 2rem;
  }
}
</style>
